var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKibana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24.473,
    viewBox: "0 0 23 24.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2614",
    "data-name": "Group 2614",
    transform: "translate(2.75, 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M19.134,21.1a17.929,17.929,0,0,1,8.437,2.13L36.51,12.5H18.8v8.6Z",
    transform: "translate(-18.8 -12.5)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M27.571,38.2,18.8,48.767v1.671H36.468A17.827,17.827,0,0,0,27.571,38.2Z",
    transform: "translate(-18.8 -27.466)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M27.571,38.2,18.8,48.767v1.671h3.133l8.521-10.275s-.585-.459-1.378-1.044C28.49,38.7,27.571,38.2,27.571,38.2Z",
    transform: "translate(-18.8 -27.466)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M19.134,33.1H18.8V45.8L27.571,35.23A17.929,17.929,0,0,0,19.134,33.1Z",
    transform: "translate(-18.8 -24.496)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKibana);
export default __webpack_public_path__ + "static/media/kibana.d0561744c5e7ff6a66fd3dd7bde8f893.svg";
export { ForwardRef as ReactComponent };